export const getCommentsForPaper = (paperId) => (state) => (state.comments.data || []).filter((i) => i.paper_id === paperId);
